"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressCategoryEnum = void 0;
var AddressCategoryEnum;
(function (AddressCategoryEnum) {
    AddressCategoryEnum["STANDARD"] = "Standard";
    AddressCategoryEnum["MILITARY"] = "Military";
    AddressCategoryEnum["RURAL"] = "Rural";
})(AddressCategoryEnum || (exports.AddressCategoryEnum = AddressCategoryEnum = {}));
//# sourceMappingURL=types.js.map